import { server } from "../api";
import axios from "axios";
const EditProfile = async ({ id, name, IP, port, socket_port, fake_update, image }) => {
  let response = await axios.post(server + "machine/update", {
    id,
    name,
    IP,
    port: port || null,
    socket_port: socket_port || null,
    fake_update,
    image,
  });
  return response.data;
};
const ActiveMachine = async (id, active) => {
  let response = await axios.post(server + "machine/active", {
    id,
	active
  });
  return response.data;
};
const CreateMachine = async (machine) => {
  let response = await axios.post(server + "machine/create", machine);
  return response.data;
};

const DeleteMachine = async (id) => {
  let response = await axios({
    method: "DELETE",
    url: server + "machine/delete",
    data: { id },
  });
  return response.data;
};

const GetServerStatus = async (IP, port) => {
  let response = await axios({
    method: "GET",
    url: `http://${IP}:${port}/info`,
  });
  return response.data;
};
export default {
  EditProfile,
  ActiveMachine,
  CreateMachine,
  DeleteMachine,
  GetServerStatus,
};
